import Flickity from 'flickity'
import 'flickity-imagesloaded'

function flickityInit () {
    const shopPage = document.querySelector( '.woocommerce-shop' )
    if ( shopPage ) return

    const block = document.querySelector( '.wp-block-drsblocks-prods' )
    if ( !block ) return

    const mql = window.matchMedia( '(min-width: 1024px)' )
    if ( mql.matches ) return

    const items = document.querySelectorAll( '.wp-block-drsblocks-prods .c-product' )
    if ( !items.length ) return
    const holder = document.querySelector( '.wp-block-drsblocks-prods__wrapper' )
    new Flickity( holder, {
        prevNextButtons: false,
        cellAlign: 'left',
        groupCells: false,
        imagesLoaded: true,
        pageDots: false,
        adaptiveHeight: true,
        percentPosition: true,
        autoPlay: false,
        cellSelector: '.wp-block-drsblocks-prods .c-product',
        selectedAttraction: 0.05,
        wrapAround: false,
        friction: 0.5
    } )
}
document.addEventListener( 'DOMContentLoaded', flickityInit )